// extracted by mini-css-extract-plugin
export default {"noteBox":"notes-item_noteBox__S2150","editIcon":"notes-item_editIcon__4A3R7"};